
import React,  { useEffect, useState, useRef } from "react";
import { Grid } from "@mui/material";
import { connect, useSelector, useDispatch } from 'react-redux';

// custom utils
import { DrawChart } from "../charts/TVChart";
// import { TopBar } from "../bars/EtfWatchBars";
import { TopBar } from "../bars/StockWatchBars";
import { useWindowDimensions } from "../pages/Utils";

// local json files
import etfs from "../data/etfgrouped.json";


const ETFWatch = ({ navbarSize, topbarSize, interval, darkMode }) => {

    // handle list of index
    const groupNames = etfs.map(v => v.Name);
    const [selectList, setSelectList] = useState(etfs[0].Name);

    const [groupItems, setGroupItems] = useState(etfs[0].Items);

    const [symbol, setSymbol] = useState(etfs[0].Items[0]);

    const handleWatchlist = (e) => {
        let ln = e.target.value;
        let idx = groupNames.indexOf(ln);
        setGroupItems(etfs[idx].Items);
        setSelectList(ln);
        setSymbol(etfs[idx].Items[0]);
        // handleFocus();
    }

    // show comments canvas
    const [showCanvas, setShowCanvas] = useState(false);
    const closeCanvas = () => setShowCanvas(false);
    const openCanvas = () => setShowCanvas(true);

    // setting chart dimensions *** potential to improve ***
    const topHeight = navbarSize + topbarSize + 10
    const chartWidth = useWindowDimensions().width;
    const chartHeight = useWindowDimensions().height;


    return (
        <div>
        <div>
        <TopBar            
            indexList={ groupNames }
            selectList={ selectList }
            handleWatchlist={ handleWatchlist }
        >
        </TopBar>
        </div>
        
        <Grid container sx={{
            minHeight: chartHeight - topHeight,
            backgroundColor: '#131722',
        }}>
            <Grid item xs={12}>
                <DrawChart
                width={chartWidth}
                height={chartHeight - topHeight}
                symbol={symbol}
                watchlist={ groupItems }
                interval={ interval }
                darkMode={ darkMode }
                ></DrawChart>
            </Grid>
        </Grid>
        </div>
    )
}

const mapStateToProps = (state) => {
    return ({
        navbarSize: state.barSize.navbarSize,
        topbarSize: state.barSize.topbarSize,
        interval: state.settings.interval,
        darkMode: state.settings.darkMode,
    })
};
  
export default connect( mapStateToProps ) (ETFWatch);
